<template>
  <div class="configure_property">
    <!-- <div class="configure_property__reload">
      <p class="configure_property__text--title_access" >
        Configurar Inmueble
      </p>
    </div> -->

    <div class="table_card">
      <div class="table_card__head" style="padding: 35px 25px">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
              Selección de Inmueble
            </p>
            <button
              class="faccess_button my-3"
              style="position: absolute; right: 25px;"
              @click="toggleSelection()"
              v-show="selected_location">
              {{ select_option ? 'Cancelar' : 'Seleccionar varios' }}
            </button>
          </v-flex>
        </v-layout>
      </div>

      <v-layout>
        <v-flex class="configure_property__selector--initial_selector">
          <v-card-text class="configure_property__selector--card">
            <v-list two-line>
              <template v-for="(location, index_l) in locations">
                <v-list-tile
                  :key="index_l"
                  avatar
                  ripple
                  @click="toggleLocation(location.id)"
                  class="configure_property__selector--item"
                >
                  <v-list-tile-content>
                    <div
                      class="configure_property__selector--item_title"
                      :style="location.id == selected_location ? 'font-weight: 600; color: #2196f3' : ''">
                      {{ location.attributes.name }}
                  </div>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider
                  v-if="index_l + 1 < locations.length"
                  :key="'dl'+index_l"
                ></v-divider>
              </template>
            </v-list>
          </v-card-text>
        </v-flex>

        <v-divider vertical></v-divider>

        <v-flex xs12 md6 class="configure_property__selector--initial_selector">
          <v-card-text class="configure_property__selector--card">
            <v-list two-line>
              <v-list-tile
                  avatar
                  ripple
                  @click="toggleSelectedSublocations()"
                  class="configure_property__selector--item"
                  v-if="select_option">
                    <div
                      class="configure_property__selector--item_title"
                      :style="selection_counter == sublocations.length ? 'font-weight:600; color: #2196f3;' : ''">
                        Seleccionar todos

                        <v-checkbox
                          style="display: flex; justify-content: flex-end; margin-top:0;"
                          :input-value="selection_counter == sublocations.length"
                          color="#2196f3"
                          hide-details>
                        </v-checkbox>
                    </div>
                </v-list-tile>

              <template v-for="(sublocation, index_s) in sublocations">
                <v-list-tile
                  :key="index_s"
                  avatar
                  ripple
                  @click="toggleSublocation(sublocation.id)"
                  class="configure_property__selector--item">

                    <div
                      class="configure_property__selector--item_title"
                      :style="sublocation.id == selected_sublocation ? 'font-weight:600; color: #2196f3;' : '' "
                      v-if="!select_option">
                      {{ sublocation.name }}
                    </div>

                    <div
                      class="configure_property__selector--item_title"
                      :style="selected_sublocations.includes(sublocation.id) ? 'font-weight:600; color: #2196f3;' : ''"
                      v-else>

                      {{ sublocation.name }}

                      <v-checkbox
                        style="display: flex; justify-content: flex-end; margin-top:0;"
                        :input-value="selected_sublocations.includes(sublocation.id)"
                        color="#2196f3"
                        hide-details>
                      </v-checkbox>
                    </div>
                </v-list-tile>
                <v-divider
                  v-if="index_s + 1 < sublocations.length"
                  :key="'ds'+index_s"
                ></v-divider>
              </template>
            </v-list>
          </v-card-text>
        </v-flex>

        <v-divider vertical></v-divider>

        <v-flex xs12 md6 :class="select_option ? 'configure_property__selector--main_selector center' : 'configure_property__selector--main_selector'">
          <v-card-text class="configure_property__selector--card" v-if="!disabled_selection">
            <div class="table_card__body" v-if="!disabled_selection" style="padding: 8px 16px 0 16px;">
              <div class="layout row wrap">
                <div class="configure_property__payments--user_section pr-3 xs12 lg6">
                  <label class="table_card__info--label custom_input__title--colapsed">
                    Usuario Asignado
                  </label>
                  <input type="text" disabled class="configure_property__payments--user" v-model="assigned_user"></div>

                  <div class="configure_property__payments--button_section">
                    <v-btn
                      class="v-btn theme--light info"
                      style="margin: 0;"
                      :disabled="disabled_selection"
                      @click="editSublocationUser()">
                      Editar
                    </v-btn>
                  </div>
                </div>

                <div class="flex" style="margin-top: 25px; max-width: 30%;">
                  <label class="table_card__info--label custom_input__title--colapsed">Año</label><br>
                  <date-picker
                      class="configure_property__payments--year_picker"
                      v-model="selected_year"
                      type="year"
                      @change="getPayments()"
                      required>
                  </date-picker>
                </div>
            </div>
            <v-list>
              <template v-for="(payment, index_s) in payments">
                <div :key="index_s" :id="index_s" class="configure_property__payment">

                  <div class="configure_property__payment--month">
                    <span>
                      {{ payment.name }}
                    </span>
                  </div>

                  <div
                    v-if="payment.state ==='COMPLETED'"
                    class="configure_property__payment--amount"
                    style="color: #4caf50 !important;">
                    <v-text-field
                      class="v-input--is-focused theme--light primary-text configure_property__payments--completed_payment"
                      :disabled="payment.state != 'PENDING'"
                      v-model="payment.amount"
                      prefix="$"
                      type="number">
                    </v-text-field>
                  </div>

                  <div
                    class="configure_property__payment--amount"
                    style="color: #f44336;"
                    v-else-if="payment.state === 'PENDING' && payment.in_arrears">
                    <v-text-field
                      class="v-input--is-focused theme--light primary-text configure_property__payments--arrear_payment"
                      :disabled="payment.state != 'PENDING'"
                      v-model="payment.amount"
                      prefix="$"
                      type="number">
                    </v-text-field>
                  </div>

                  <div
                    class="configure_property__payment--amount"
                    style="color: #5A6B8E"
                    v-else>
                    <v-text-field
                      class="v-input--is-focused theme--light primary-text"
                      :disabled="payment.state != 'PENDING'"
                      v-model="payment.amount"
                      prefix="$"
                      type="number">
                    </v-text-field>
                  </div>

                  <div class="configure_property__payment--send_btn">
                    <v-btn
                      style="width: 50%; background-color: #1476FB;"
                      class="v-btn theme--light info"
                      round
                      @click="showConfirmModal(payment.payment_id, payment.month, payment.amount, getPaymentMethod())"
                      v-if="payment.state === 'PENDING' && payment.support_files.length === 0">
                      {{ payment.notified ? 'Reenviar' : 'Enviar'}}
                    </v-btn>

                    <v-btn
                      style="width: 50%;"
                      class="v-btn theme--light success"
                      round
                      @click="showSupportFileModal(payment, payment.support_files)"
                      v-else>
                      Ver
                    </v-btn>
                  </div>
                </div>

                <v-divider
                  v-if="index_s + 1 < payments.length"
                  :key="'ds'+index_s">
                </v-divider>

              </template>
            </v-list>
          </v-card-text>

          <button
            class="faccess_button my-3"
            style="margin-right: 20px;"
            :disabled="!selected_sublocations.length > 0"
            v-else-if="select_option"
            @click="show_send_payments_modal = true">
            Crear pago ({{ selected_sublocations.length }})
          </button>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
    </div>

    <v-dialog v-model="show_send_payments_modal" max-width="700px" persistent>
      <form class="configure_property__send_payments_modal">
        <span
          class="configure_property__send_payments_modal--close_btn"
          @click="restoreSendPaymentsModal()">
          Cerrar
        </span>

        <v-select
          class="configure_property__send_payments_modal--month"
          v-model="mass_payments_month"
          :label="mass_payments_month"
          :items="months"
          solo>
        </v-select>

        <v-text-field
          class="configure_property__send_payments_modal--amount"
          solo
          v-model="mass_payments_amount"
          placeholder="150,000"
          prefix="$"
          type="number"
          @keyup="validAmount = true">
        </v-text-field>

        <v-btn
          style="margin-bottom: 20px;"
          color="primary"
          @click="validateAmount()">
          Enviar
        </v-btn>

        <span class="configure_property__send_payments_modal--alert" v-if="!validAmount">
          *Por favor ingrese un monto valido*
        </span>
      </form>
    </v-dialog>

    <section
      v-if="show_confirm_modal"
      class="access_devices__modal">
      <section class="access_devices__modal--container">
        <p class="access_devices__modal--text" v-if="select_option">
          ¿Esta seguro que desea notificar el pago de la administración a los propietarios de las locaciones seleccionadas?
        </p>
        <p class="access_devices__modal--text" v-else>
          ¿Esta seguro que desea notificar el pago de la administración a este usuario?
        </p>
        <div class="access_devices__modal--buttons">
          <div
            class="access_devices__modal--button"
            @click="show_confirm_modal = false">
            Cancelar
          </div>
          <div
            class="access_devices__modal--button active"
            @click="sendMassNotifications()"
            v-if="select_option">
            Si
          </div>
          <div
            class="access_devices__modal--button active"
            @click="sendPaymentNotification()"
            v-else>
            Si
          </div>
        </div>
      </section>
    </section>

    <support-file-modal
      v-if="show_support_modal"
      :support_files="selected_support_files"
      :referenceDate="selected_support_date"
      @closeSupportModal="closeSupportModal()"
      @modifySupportState="modifySupportFileState($event)"
    >
    </support-file-modal>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        locations: [],
        sublocations: [],
        select_option: false,
        selected_sublocations: [],
        months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        mass_payments_amount: '',
        mass_payments_month: '',
        selected_location: '',
        selected_sublocation: '',
        disabled_selection: true,
        selected_year: new Date(),
        selected_month: '',
        selected_amount: '',
        selected_external_link: '',
        selected_payment_id: null,
        selected_support_file: '',
        selected_support_date: '',
        payments: [],
        assigned_user: '',
        pages: 1,
        show_confirm_modal: false,
        show_send_payments_modal: false,
        show_support_modal: false,
        validAmount: true,
        selection_counter: 0
      }
    },
    methods: {
      toggleSelection(){
        if(!this.select_option){
          this.select_option = true
          this.disabled_selection = true

        } else this.cleanUp()

      },
      toggleLocation(id){
        if(this.selected_location == id){
          this.selected_location = ''
          this.sublocations = []
          this.disabled_selection = true
        }else{
          this.selected_location = id
          this.selected_sublocation = ''
          this.disabled_selection = true
        }
        if(this.selected_location != null && this.selected_location != ''){
          this.getSublocations()
        }
      },
      toggleSublocation(id){
        if(this.select_option){
          if(this.selected_sublocations.includes(id)){
            this.selected_sublocations.splice(this.selected_sublocations.indexOf(id), 1)
            this.selection_counter -= 1
          } else {
            this.selected_sublocations.push(id)
            this.selection_counter += 1
          }
        }else if(this.selected_sublocation == id){
          this.selected_sublocation = ''
          this.disabled_selection = true
        }else{
          this.selected_sublocation = id
          this.disabled_selection = false
          this.getPayments()
        }
      },
      toggleSelectedSublocations(){
        if(this.selection_counter < this.sublocations.length){
          this.sublocations.forEach(subl => {
            if(!this.selected_sublocations.includes(subl.id)){
              this.selected_sublocations.push(subl.id)
              this.selection_counter += 1
            }
          })

        } else {
          this.sublocations.forEach(subl => {
            this.selected_sublocations.splice(this.selected_sublocations.indexOf(subl.id), 1)
          })
          this.selection_counter = 0
        }
      },
      updateSelectionCounter(){
        this.selection_counter = 0
        this.sublocations.forEach(subl => {
          if(this.selected_sublocations.includes(subl.id)) this.selection_counter += 1
        })
      },
      findLocations(){
        let params = { page: this.page }
        const data={company:{id:this.getCompany().id}}
        try {
          this.$http.post('locations/company',{data:this.encrypt(data).toString()},{
            headers:
            {"X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()},
            params
          })
          .then(function(response){
            this.locations = response.body.data
            this.pages = response.body.meta.pages
            console.log("page <<<<<", this.page)
            console.log("pages <<<<<", this.pages)
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
        } catch (e) {
          alert(e.message)
        }
      },
      getCurrentPaymentMethod(){
        try {
          this.$http.get('payment_methods/find_current',
            {
              params: {
                company: { id: this.getCompany().id }
              },
              headers: {
                "X-Device-ID": this.getDeviceId(),
                "Authorization": 'Bearer ' + this.getUserToken()
              }
            }
          ).then(response => {
            if(response.body.data != null && response.body.data != ''){
              this.updatePaymentMethod(response.body.data.attributes.link)
            } else {
              this.show_send_payments_modal = false
              this.updateAlertMessage("No hay métodos de pago asignados");
              this.updateIsInAlert(true)
            }

            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(typeof response.body.errors[0].details != "object"){
              alert(response.body.errors[0].details);
            }else{
              let message = []
              for(var key in response.body.errors[0].details){
                message.push(response.body.errors[0].details[key])
              }
              alert(message);
            }
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })

        } catch (e) {
          alert(e.message)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }
      },
      getSublocations(){
        try{
          this.$http.get('app/sublocations', {
            headers: {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            },
            params:{ location_id: this.selected_location }
          }).then(function(response){
            this.sublocations=response.body;
            this.updateSelectionCounter()

            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            if (response.status==401) {
              // alert(response.body.errors[0].details, "Un momento...");
              this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
              this.updateIsInAlert(true)
            }else{
              this.updateAlertMessage(response.body.errors[0].title);
              this.updateIsInAlert(true)
            }
          });
        }catch(e){
          alert(e.message);
        }
      },
      editSublocationUser(){
        this.$router.push({name: 'sublocation_user', params: {sublocation_id: this.selected_sublocation}})
      },
      getPayments(){
        if(this.selected_year){
          this.resetPayments()
          try{
            this.$http.get('payments', {
              headers: {
                "X-Device-ID" : this.getDeviceId(),
                "Authorization" : 'Bearer ' + this.getUserToken()
              },
              params:{ sublocation_id: this.selected_sublocation, year: this.selected_year.getFullYear() }
            }).then(function(response){
              this.assigned_user = response.body.meta.assigned_user;
              response.body.data.forEach((value) => {
                let month = new Date(value.attributes.reference_date).getMonth() + 1
                let payment = this.payments.find(item => item.month === month);
                payment.payment_id = value.id
                payment.amount = value.attributes.amount ? value.attributes.amount : ''
                payment.state = value.attributes.state
                payment.reference_date = value.attributes.reference_date
                payment.external_link = value.attributes.external_link
                payment.notified = value.attributes.notified
                payment.support_files = value.attributes.support_files
                if (value.attributes.state === 'PENDING' && value.attributes.support_files !== undefined && value.attributes.support_files.length > 0){
                  let last_support = value.attributes.support_files[value.attributes.support_files.length - 1]
                  if(new Date(value.attributes.limit_date) < new Date() && last_support.state === 'REJECTED'){
                    payment.in_arrears = true
                  }
                }else if(value.attributes.state === 'PENDING' && (value.attributes.support_files === undefined || value.attributes.support_files.length == 0)){
                  if(new Date(value.attributes.limit_date) < new Date()){
                    payment.in_arrears = true
                  }
                }
              });
              if(response.body.meta != undefined && response.body.meta != null){
                if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
            }, function(response){
              if(response.body.meta != undefined && response.body.meta != null){
                if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
              if (response.status==401) {
                // alert(response.body.errors[0].details, "Un momento...");
                this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                this.updateIsInAlert(true)
              }else{
                this.updateAlertMessage(response.body.errors[0].details);
                this.updateIsInAlert(true)
              }
            });
          }catch(e){
            alert(e.message);
          }
        } else this.payments = []
      },
      validateAmount(){
        if(parseInt(this.mass_payments_amount) >= 0 && this.mass_payments_amount != '') {
          this.showConfirmModal(null, this.mass_payments_month, this.mass_payments_amount, this.getPaymentMethod())
        } else this.validAmount = false
      },
      showConfirmModal(payment_id, month_number, amount, external_link){
        if(external_link){
          this.show_confirm_modal = true
          this.selected_month = month_number
          this.selected_amount = amount
          this.selected_external_link = external_link
          this.selected_payment_id = payment_id
        } else {
          this.show_send_payments_modal = false
          this.updateAlertMessage("No hay métodos de pago asignados");
          this.updateIsInAlert(true)
        }
      },
      sendPaymentNotification(){
        console.log( this.selected_payment_id, this.selected_sublocation,this.selected_external_link)
        let data = {
          sublocation_id: this.selected_sublocation,
          payment_id: this.selected_payment_id,
          amount: this.selected_amount,
          external_link: this.selected_external_link,
          concept: "Administración",
          month: this.selected_month,
          year: this.selected_year.getFullYear()
        }

        try {
          this.$http.post('payments/create_payment',{ data: this.encrypt(data).toString()},
          {
            headers:{
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
          })
          .then(function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
                
              }
            }
            this.getPayments()
            this.updateAlertMessage(response.body.ans)
            this.updateIsInAlert(true)
            // this.$router.push({name: 'configure_property'})
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            this.updateAlertMessage(response.body.ans);
            this.updateIsInAlert(true);
          })
        } catch (e) {
          this.updateAlertMessage(e.message);
          this.updateIsInAlert(true);
        }
        this.show_confirm_modal = false
      },
      sendMassNotifications(){
        const data = []
        this.selected_sublocations.forEach(subl => data.push({
          sublocation_id: subl,
          payment_id: null,
          amount: this.mass_payments_amount,
          month: this.months.indexOf(this.mass_payments_month) + 1,
          year: new Date().getFullYear()
        }))

        try {
          this.$http.post("payments/send_payments", { data: this.encrypt(data).toString() },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              "Authorization": this.getUserToken()
            }
          })
          .then(response => {
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            this.updateAlertMessage(response.body.ans)
            this.updateIsInAlert(true)
            this.cleanUp()
            this.restoreSendPaymentsModal()

          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            this.updateAlertMessage(response.body.ans)
            this.updateIsInAlert(true)

          })
        } catch (e) {
          this.updateAlertMessage(e.message)
          this.updateIsInAlert(true)
        }

        this.show_confirm_modal = false
        this.show_send_payments_modal = false
      },
      resetPayments(){
        this.payments = [
          {payment_id: null, month: 1, name: "Enero", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 2, name: "Febrero", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 3, name: "Marzo", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 4, name: "Abril", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 5, name: "Mayo", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 6, name: "Junio", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 7, name: "Julio", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 8, name: "Agosto", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 9, name: "Septiembre", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 10, name: "Octubre", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 11, name: "Noviembre", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
          {payment_id: null, month: 12, name: "Diciembre", amount: "0", state: "PENDING", reference_date: "", external_link: "", support_files: [], in_arrears: false, notified: false},
        ]
      },
      closeSupportModal(){
        this.show_support_modal = false;
      },
      showSupportFileModal(payment, support_files){
        this.show_support_modal = true
        this.selected_support_date = payment.reference_date
        this.selected_support_files = support_files
        this.selected_payment_id = payment.payment_id
      },
      modifySupportFileState(support_file){
        let data = {
          payment_id: this.selected_payment_id,
          support_file_id: support_file.support_id,
          approved: support_file.value
        }
        try {
          this.$http.post('payments/update_payment_support_state',{ data: this.encrypt(data).toString()},
          {
            headers:{
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
          })
          .then(function(response){
            this.updateAlertMessage(response.body.ans)
            this.updateIsInAlert(true)
            this.show_support_modal = false
            this.getPayments()
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
        } catch (e) {
          alert(e.message)
        }
      },
      cleanUp(){
        this.select_option = false
        this.selected_sublocation = ''
        this.selected_sublocations = []
        this.mass_payments_amount = ''
        this.selection_counter = 0
      },
      restoreSendPaymentsModal(){
        this.show_send_payments_modal = false
        this.mass_payments_amount = ''
        this.validAmount = true
      }
    },
    mounted(){
      this.findLocations()
      this.getCurrentPaymentMethod()
      this.mass_payments_month = this.months[new Date().getMonth()]
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/users/configure_property/Index.vue